import { AxiosError, AxiosResponse } from 'axios';

import { logOut } from '@/helpers/auth';
import { toast } from '@flash-global66/g-toast';
import { ErrorsCommon } from '@/shared/common/errors';
import { handleAxiosError } from '@/helpers/error';
import { GAxiosError } from '@/types/errorType';
import { captureApiErrorTrace } from '@/core/sentry';

const handleUnauthorized = (error: AxiosError) => {
  const excludeEndpoints = [
    'auth-server/b2b/auth/login',
    'auth-server/b2b/otp',
    'auth-server/pin',
    'customer/b2b/onboarding/validate-otp',
    'beneficiary/b2b',
    'auth-server/b2b/session/refresh',
    'company/b2b/executive',
    'auth-server/b2b/auth/logout',
  ];

  const headers = error?.config?.headers;
  const hasCode = headers?.authvalue?.length || headers?.authValue?.length;

  const e = error as GAxiosError;
  const requestUrl = error?.config?.url || '';
  const isExcludedUrl = excludeEndpoints.includes(requestUrl);
  const mappedReasons = Object.keys(ErrorsCommon);

  if (
    !isExcludedUrl &&
    mappedReasons.includes(e.response?.data?.reason || '')
  ) {
    const errorMessage = handleAxiosError({
      error,
      errorMap: ErrorsCommon as unknown as Record<string, string>,
    });

    toast.error(errorMessage);
  }

  if (isExcludedUrl || !!hasCode) {
    return;
  }
  logOut();
};

export const responseInterceptor = (response: AxiosResponse): AxiosResponse => {
  return response;
};

export async function responseErrorInterceptor(
  error: AxiosError
): Promise<AxiosError> {
  if (!error.response) {
    return Promise.reject(error);
  }

  const { status } = error.response;

  captureApiErrorTrace(error);

  switch (status) {
    case 401:
      handleUnauthorized(error);
      break;
    default:
      break;
  }

  return Promise.reject(error);
};
